export default "__VITE_PUBLIC_ASSET__cc57ac03__"